/**
 * Application Constants
 *
 * Centralized constants for API endpoints, delays, validation rules, and other magic values.
 * This helps maintain consistency and makes it easier to update values across the codebase.
 */

/**
 * API Endpoints
 * All API route paths used throughout the application
 */
export const API_ENDPOINTS = {
  ADDRESS_VERIFICATION: '/api/address-verification',
  ADDRESS_AUTOCOMPLETE: '/api/autocomplete-address',
  SWAG_FORM: '/api/swag-form',
  CONTACT_FORM: '/api/contact-report-form',
  MARKETPLACE_QUOTE: '/api/marketplace-quote',
  TRIGGER_FORM: '/api/trigger-form',
  CMMC_READINESS_GATE: '/api/cmmc-readiness-assessment',
} as const

/**
 * Debounce Delays (in milliseconds)
 * Used for input debouncing to reduce API calls
 */
export const DEBOUNCE_DELAYS = {
  ADDRESS_AUTOCOMPLETE: 300,
  SEARCH: 500,
} as const

/**
 * Validation Rules
 * Common validation constraints used across forms
 */
export const VALIDATION_RULES = {
  MIN_ADDRESS_LENGTH: 3,
  MAX_ADDRESS_LENGTH: 200,
  MIN_SEARCH_LENGTH: 2,
  MAX_SEARCH_LENGTH: 100,
} as const

/**
 * Form Messages
 * Standard form submission messages
 */
export const FORM_MESSAGES = {
  SUBMITTING: 'Submitting...',
  SUBMITTING_REQUEST: 'Submitting your request...',
  SUCCESS_SWAG: 'Your swag request has been submitted successfully!',
  SUCCESS_GENERIC: 'Success!',
  ERROR_SWAG: 'There was an error submitting your request. Please try again.',
  ERROR_GENERIC: 'Submission failed',
  ERROR_ADDRESS: 'Failed to verify address',
  ERROR_AUTOCOMPLETE: 'Failed to fetch address suggestions',
} as const

/**
 * Timeouts (in milliseconds)
 * Used for delays and timeouts throughout the application
 */
export const TIMEOUTS = {
  SUCCESS_CALLBACK_DELAY: 500,
  DEBOUNCE_DEFAULT: 300,
} as const
